import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-web-designing',
  templateUrl: './web-designing.component.html',
  styleUrls: ['./web-designing.component.css']
})
export class WebDesigningComponent implements OnInit {

  constructor(private route: Router) { }

  ngOnInit(): void {
  }
  changeRouteTo(arr){
    this.route.navigate(arr);
  }
}
